exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spinner {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n}\n\n.no-data-available {\n  position: absolute;\n  top: 50%;\n  left: 45%;\n  font-size: 16px;\n  font-weight: bold;\n}\n\n", ""]);

// exports
